import { TabProps, TabCard } from 'components';
import { useTranslation } from 'react-i18next';
import { PictureOutlined, FileOutlined, DotChartOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Col, Row, Space } from 'antd';
import { useEffect, useState } from 'react';
import Pictures from './Tabs/Pictures';
import Attachments from './Tabs/Attachments';
import Samples from './Tabs/Samples';
import DownloadMeasurments from './Actions/DownloadMeasurments';
import ToggleChartInteraction from './Actions/ToggleChartInteraction';
import NewSample from './Actions/NewSample';
import ChartTab from './Tabs/ChartTab';
import CommentsTab from './Tabs/CommentsTab';
import ManageCommentsButton from './Actions/ManageCommentsButton';
import Tools from './Tabs/Tools';
import NewTool from './Actions/NewTool';
import { useScreenBreakpoint } from 'hooks/useScreenBreakpoint';

const AdditionalInfoTabs = () => {
  const { t } = useTranslation();
  const { isMobile } = useScreenBreakpoint();
  const [ isChartInteractive, setIsChartInteractive ] = useState(!isMobile);

  useEffect(() => {
    setIsChartInteractive(!isMobile);
  }, [ isMobile ]);

  const chartActions = <Space size='small'>
    <DownloadMeasurments />
    {isMobile && (
      <ToggleChartInteraction
        isInteractive={isChartInteractive}
        onToggle={() => setIsChartInteractive((prev) => !prev)}
      />
    )}
  </Space>;

  const tabs: TabProps[] = [
    {
      key: 'chart',
      title: t('tabs.chart'),
      icon: <DotChartOutlined />,
      content: <ChartTab isInteractive={isChartInteractive} />,
      actions: chartActions,
      isActive: true
    },
    {
      key: 'pictures',
      title: t('tabs.pictures'),
      icon: <PictureOutlined />,
      content: <Pictures />
    },
    {
      key: 'attachments',
      title: t('tabs.attachments'),
      icon: <PaperClipOutlined />,
      content: <Attachments />
    },
    {
      key: 'samples',
      title: t('tabs.samples'),
      icon: <FileOutlined />,
      content: <Samples />,
      actions: <NewSample />
    },
    {
      key: 'comments',
      title: t('tabs.comments'),
      icon: <FileOutlined />,
      content: <CommentsTab />,
      actions: <ManageCommentsButton/>
    },
    {
      key: 'tools',
      title: t('tabs.tools'),
      icon: <FileOutlined />,
      content: <Tools />,
      actions: <NewTool/>
    },
  ];

  const header = (
    <Row justify="space-between">
      <Col>
        <Space>
          <div className="title">{`${t('common.additional')}`}</div>
        </Space>
      </Col>
    </Row>
  );

  return <TabCard tabs={tabs} title={header} />;
};

export default AdditionalInfoTabs;